import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'free-solar-quotes-sydney';
const serviceId = 5
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Free Solar Quotes Sydney | ${BUSINESS_NAME}`,
        description: "Obligation-free consultations to design the right solar package. Get clear advice and upfront pricing from trusted Sydney solar specialists.",
        keywords: "free solar quotes Sydney, solar consultation, solar package design, solar pricing Sydney, trusted solar specialists, solar energy advice, residential solar quotes, commercial solar quotes, solar installation estimates, sustainable energy solutions",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Free Solar Quotes',
    description: 'Obligation-free consultations to design the right solar package. Get clear advice and upfront pricing from trusted Sydney solar specialists.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
